<template>
  <div class="telemetry-tire-temperature-fr-parts">
    <img
      v-if="heatFlag === 'cold'"
      class="telemetry-tire-temperature-fr-parts__tire"
      :src="require('@/assets/img/RaceVideoPage/telemetry/tire_front_right_cold.svg')"
      alt=""
    />
    <img
      v-else-if="heatFlag === 'normal'"
      class="telemetry-tire-temperature-fr-parts__tire"
      :src="require('@/assets/img/RaceVideoPage/telemetry/tire_front_right.svg')"
      alt=""
    />
    <img
      v-else-if="heatFlag === 'hot'"
      class="telemetry-tire-temperature-fr-parts__tire"
      :src="require('@/assets/img/RaceVideoPage/telemetry/tire_front_right_hot.svg')"
      alt=""
    />

    <p
      class="telemetry-tire-temperature-fr-parts__data"
      :class="`telemetry-tire-temperature-section__tire_temperature--${heatFlag}`"
    >
      <span class="telemetry-tire-temperature-fr-parts__data__number">{{
        viewValue.toFixed(1)
      }}</span>
      <span class="telemetry-tire-temperature-fr-parts__data__unit">°C</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

export type DataType = {
  viewValue: number
  comparisonValue: number
}

/**
 * レース動画再生画面 テレメトリー タイヤ温度 フロント右 値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryTireTemperatureFrParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * 表示fpsと受信データ間隔の差分ms
     */
    diffMs: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { value } = toRefs(props)
    const { getHeatFlag, setupIntermediateValue } = useTelemetrySectionUtil()
    const heatFlag = getHeatFlag(value)
    const viewValue = setupIntermediateValue(value, props.diffMs)

    return {
      heatFlag,
      viewValue,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-tire-temperature-fr-parts {
  &__tire {
    position: absolute;
    left: 50%;
    top: 16%;
    transform: translateX(-50%);
    width: 8.5em;
    height: 5.25em;
    z-index: 1;
  }

  &__data {
    position: absolute;
    top: 16%;
    right: 12.5%;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 5.1667em;
    height: 2em;
    padding: 0 0.333em;
    border-radius: 2px;

    &__number {
      font-size: 1.333em;
      letter-spacing: 0.02em;
      line-height: 1.37;
    }

    &__unit {
      font-size: max(0.9167em, 8px);
      margin-left: 0.1667em;
      line-height: 1;
    }
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-tire-temperature-fr-parts {
      &__tire {
        top: 10%;
      }

      &__data {
        top: 8%;

        &__number {
          font-size: 1.471em;
        }

        &__unit {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
